import React, { useState, useEffect } from "react";
import {
  TextField,
  MenuItem,
  Button,
  Grid,
  IconButton,
  Container,
  TableContainer,
  Table,
  Dialog,
  Box,
  DialogTitle,
  DialogContent,
  TableCell,
  Autocomplete,
  TableHead,
  TableRow,
  TableBody,
  AutoComplete,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  GoodReceivedCreate,
  DivisionList,
  ApproveSolistapi,
  fetchpos,
  getUnits,
  getAllItems,
  fetchItemsByCategoryAndSubcategory,
  getCategories,
  fetchSubCategories,
  GoodReceivedUpdate,
  GetNextGRNo,
} from "../../../Services/Services";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";


import { useCallback } from "react";
import { debounce } from "lodash";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { CircularProgress } from "@mui/material";

const GoodReceivedForm = () => {
  const [formData, setFormData] = useState({
    division: "",
    project: "",
    purchase: "",
    items: [
      {
        category: "",
        sub_category: "",
        item: "",
        description: "",
        quantity: "",
        received_qty: "",
        unit: "",
        rate: "",
        amount: "",
      },
    ],
    created_by: localStorage.getItem("user_id"),
  });
  const navigate = useNavigate();
  const [gr_no, setGr_no] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [projects, setProjects] = useState([]);
  const [purchases, setPurchases] = useState([]);
  const [itemOptions, setItemOptions] = useState({});
  const [openItemModal, setOpenItemModal] = useState(false);
  const [subcategories, setSubcategories] = useState([]);
  const [loading, setLoading] = useState(false); // 🔹 loader state

  const [categories, setCategories] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [rowErrors, setRowErrors] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [items, setItems] = useState({});

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const editIssue = location.state?.issue || null;
  const fetchItems = async () => {
    const data = await getAllItems();
    if (Array.isArray(data)) {
      setItemOptions(data);
    }
  };
  useEffect(() => {
    fetchItems();
    fetchNextGRNo();
    getCategories().then((data) => {
      setCategories(Array.isArray(data) ? data : data?.results || []);
    });
  }, []);
  const fetchNextGRNo = async () => {
    const data = await GetNextGRNo();
    if (data && data.gr_no) {
      setFormData((prev) => ({
        ...prev,
        gr_no: data.gr_no,
      }));
    }
  };
  useEffect(() => {
    if (editIssue) {
      setFormData({
        gr_no: editIssue.gr_no || "",
        division: editIssue.division || "",
        project: editIssue.project || "",
        purchase: editIssue.purchase || "",
        created_by: editIssue.created_by || localStorage.getItem("user_id"),
        items:
          editIssue.items?.map((item) => ({

            category: item.category?.id || item.category,
            category_name:
              item.category?.name || item.category_name || "",
            sub_category: item.sub_category?.subcat_id || item.sub_category?.id || item.sub_category || null,
            sub_category_name:
              item.sub_category?.name || item.sub_category_name || "",
            item: item.item?.id || item.item || null,
            item_name: item.item?.name || item.item_name || "",
            description: item.description || "",
            received_qty: item.received_qty || "",
            quantity: item.quantity || "",
            unit: item.unit?.id || item.unit || "",
            unit_name: item.unit || item.unit?.id || "",
            rate: item.rate || "",
            amount: item.amount || "",
          })) || [],
      });
    }
  }, [editIssue]);

  const fetchPOs = async () => {
    const data = await fetchpos();
    if (Array.isArray(data.results)) {
      setPurchases(data.results);
    }
  };

  useEffect(() => {
    fetchPOs();
    getUnits().then((data) => {
      setUnitOptions(Array.isArray(data) ? data : data?.results || []);
    });
  }, []);

  useEffect(() => {
    const fetchDivisions = async () => {
      try {
        const data = await DivisionList();
        const divisionsArray = Array.isArray(data) ? data : data?.results || [];
        const names = divisionsArray.map((division) => ({
          id: division.division_id,
          name: division.division,
        }));
        setDivisions(names);
      } catch (err) {
        console.error(err);
        setDivisions([]);
      }
    };
    fetchDivisions();
  }, []);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await ApproveSolistapi();
        const projectsArray = Array.isArray(data) ? data : data?.results || [];
        const mappedProjects = projectsArray.map((project) => ({
          id: project.id,
          project_name: project.project_name,
          client_name: project.client_name,
          company_name: project.company_name,
          shipping_address: project.shipping_address,
          email: project.email,
          shipping_contact: project.shipping_contact,
          gst_no: project.gst_no,
          pan_no: project.pan_no,
        }));
        setProjects(mappedProjects);
      } catch (err) {
        console.error(err);
        setProjects([]);
      }
    };
    fetchProjects();
  }, []);

  useEffect(() => { }, [projects]);
  // 🔹 Purchase Order change pe autofill

  const handleInputChange = (index, field, value) => {
    const updatedItems = [...formData.items];
    updatedItems[index][field] = value;

    setFormData((prev) => ({
      ...prev,
      items: updatedItems,
    }));
  };

  const handleItemChange = (index, e) => {
    const { name, value } = e.target;
    const items = [...formData.items];
    items[index][name] = value;

    if (name === "item") {
      const selected = itemOptions.find((opt) => opt.id === parseInt(value));
      if (selected) {
        items[index].unit = selected.unit_name;
      }
    }

    // Recalculate amount
    const qty = parseFloat(items[index].quantity || 0);
    const rate = parseFloat(items[index].rate || 0);
    items[index].amount = (qty * rate).toFixed(2);

    setFormData((prev) => ({ ...prev, items }));
  };

  const addItem = () => {
    setFormData((prev) => ({
      ...prev,
      items: [
        ...prev.items,
        {
          category: "",
          sub_category: "",
          item: "",
          description: "",
          quantity: "",
          received_qty: "",
          unit: "",
          rate: "",
          amount: "",
        },
      ],
    }));
  };

  const removeItem = (index) => {
    const items = formData.items.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, items }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);   // 🔹 loader start

    const cleanedItems = formData.items.map((row) => ({
      category: row.category?.id || row.category || null,
      sub_category: row.sub_category?.subcat_id || row.sub_category?.id || row.sub_category || null,
      item: row.item?.id || row.item || null,
      unit: row.unit?.id || row.unit || null,
      description: row.description,
      quantity: Number(row.quantity) || 0,
      received_qty: Number(row.received_qty) || 0,
      rate: Number(row.rate) || 0,
      amount: Number(row.amount) || 0,
    }));

    const payload = {
      gr_no: formData.gr_no,
      division: formData.division?.id || formData.division || null,
      project: formData.project?.id || formData.project || null,
      purchase: formData.purchase?.id || formData.purchase || null,
      created_by: localStorage.getItem("user_id"),
      good_items: cleanedItems,
    };

    if (!validateForm()) {
      setLoading(false);   // ❌ form invalid → loader stop
      return;
    }

    try {
      let response;
      if (editIssue?.id) {
        response = await GoodReceivedUpdate(editIssue.id, payload);
        if (response?.id) toast.success("Updated Successfully!");
      } else {
        response = await GoodReceivedCreate(payload);
        if (response?.id) toast.success("Created Successfully!");
      }
      if (response?.id) {
        setFormData({
          gr_no: "",
          division: "",
          project: "",
          purchase: "",
          items: [
            {
              category: "",
              sub_category: "",
              item: "",
              description: "",
              quantity: "",
              received_qty: "",
              unit: "",
              rate: "",
              amount: "",
            },
          ],
        });

        handleItemModalSuccess();
      }
    } catch (err) {
      console.error("❌ API Error:", err);
      toast.error("API Error!");
    } finally {
      setLoading(false);   // 🔹 loader stop (success/fail dono case me)
    }
  };

  const handleItemModalSuccess = async () => {
    const updatedItems = await getAllItems(); // or your item fetch API
    setItemOptions(updatedItems); // setItemOptions is used in your Autocomplete
  };

  const handleCloseItemModal = async () => {
    setOpenItemModal(false);
    const data = await getAllItems();
    if (Array.isArray(data)) {
      setItemOptions(data);
    }
  };
  const handlekeyInputChange = async (index, key, value) => {
    const updatedRows = [...formData.items];
    let row = updatedRows[index];
    switch (key) {
      case "category":
        row = { ...row, category: value, sub_category: null, item: null };
        if (value) {
          const subcats = await fetchSubCategories(value.id, page, searchTerm);
          const subs = [...subcategories];
          subs[index] = subcats;

          setSubcategories(subs);
        }
        break;

      case "sub_category":
        row = { ...row, sub_category: value, item: null };
        if (row.category && value) {
          const itemData = await fetchItemsByCategoryAndSubcategory(
            row.category.id,
            value.subcat_id,
            page,
            searchTerm
          );
          const mappedItems = (itemData.results || []).map((item) => ({
            id: item.id,
            name: item.name,
          }));

          setItemOptions((prev) => ({
            ...prev,
            [index]: mappedItems,
          }));
        }
        break;

      case "item":
        row = {
          ...row,
          item: value,
          unit: value?.unit || "",
        };
        break;
      default:
        row[key] = value;
        break;
    }

    updatedRows[index] = row;
    setFormData((prev) => ({
      ...prev,
      items: updatedRows,
    }));
  };

  const handleItemInputChange = useCallback(
    debounce(async (index, row, newValue, type) => {
      if (!newValue || newValue.trim() === "") {
        if (type === "category") {
          const catData = await getCategories(); // get full list
          const list = Array.isArray(catData.results)
            ? catData.results
            : catData;
          setCategories(list);
        }

        if (type === "sub_category" && row.category) {
          const subcatData = await fetchSubCategories(row.category.id);
          setSubcategories((prev) => {
            const updated = [...prev];
            updated[index] = subcatData;
            return updated;
          });
        }
        if (type === "item" && row.category && row.sub_category) {
          const itemData = await fetchItemsByCategoryAndSubcategory(
            row.category.id,
            row.sub_category.subcat_id
          );
          setItemOptions((prev) => ({
            ...prev,
            [index]: itemData.results || [],
          }));
        }
        return;
      }
      if (type === "category") {
        const catData = await getCategories(1, newValue || "");
        const list = Array.isArray(catData.results) ? catData.results : catData;

        setCategories(list);
      }
      if (type === "sub_category" && row.category) {
        const subcatData = await fetchSubCategories(
          row.category.id,
          1, // page reset
          newValue || "" // search term
        );
        setSubcategories((prev) => {
          const updated = [...prev];
          updated[index] = subcatData;
          return updated;
        });
      }
      if (type === "item" && row.category && row.sub_category) {
        const itemData = await fetchItemsByCategoryAndSubcategory(
          row.category.id,
          row.sub_category.subcat_id,
          1, // page reset
          newValue || "" // search term
        );

        const mappedItems = (itemData.results || []).map((item) => ({
          id: item.id,
          name: item.name,
        }));

        setItemOptions((prev) => ({
          ...prev,
          [index]: mappedItems,
        }));
      }
    }, 500),
    []
  );
  const validateForm = () => {
    const errors = {};
    const rowErrs = [];

    if (!formData.division) errors.division = "Division is required";
    if (!formData.project) errors.project = "Project is required";
    if (!formData.purchase) errors.purchase = "PO is required";

    formData.items.forEach((row, i) => {
      const err = {};
      if (!row.received_qty) err.received_qty = "Required";
      if (!row.rate) err.rate = "Required";
      if (!row.amount) err.amount = "Required";
      rowErrs[i] = err;
    });
    setFormErrors(errors);
    setRowErrors(rowErrs);
    return (
      Object.keys(errors).length === 0 &&
      rowErrs.every((e) => Object.keys(e).length === 0)
    );
  };
  return (
    <Box p={2}>
      <Grid
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 3,
          alignItems: "flex-end",
          width: "100%",

          mt: -5, // ✅ top margin remove
          pt: 0, // ✅ top padding remove
          mb: 2, // ✅ bottom margin rakha hua
          px: 1,
        }}
      >
        <Button
          variant="outlined"
          // color="secondary"
          onClick={() => navigate(-1)}
            sx={{
              borderRadius: 0, // ✅ sharp edges
              height: 35, // ✅ search box ke barabar
              minWidth: 120, // ✅ width match
              fontSize: "0.7rem", // ✅ text chhota
              px: 2, // ✅ left-right padding
              textTransform: "none", // ✅ UPPERCASE hatane ke liye
            }}
        >
          ← Back
        </Button>
        <Button
          variant="contained"
          type="submit"
          onClick={handleSubmit} // aapka async submit function
          disabled={loading}
            sx={{
              borderRadius: 0, // ✅ sharp edges
              height: 35, // ✅ search box ke barabar
              minWidth: 120, // ✅ width match
              fontSize: "0.7rem", // ✅ text chhota
              px: 2, // ✅ left-right padding
              textTransform: "none", // ✅ UPPERCASE hatane ke liye
            }}
        >
          {loading ? <CircularProgress size={22} color="inherit" /> : "Submit"}
        </Button>

      </Grid>
      <ToastContainer position="top-right" autoClose={3000} />
      <Box
        border="1px solid #ccc"
        borderRadius="8px"
        p={2}
        sx={{ backgroundColor: "#fff" }}
      >
        <Container maxWidth="xl">
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>

              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Goods Received No."
                  name="gr_no"
                  value={formData.gr_no || ""}

                  disabled
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 50
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  fullWidth
                  options={divisions}
                  getOptionLabel={(option) => option.name || ""} // dropdown me kya dikhega
                  value={
                    divisions.find((d) => d.id === formData.division) || null
                  } // selected value
                  onChange={(event, newValue) => {
                    setFormData({
                      ...formData,
                      division: newValue ? newValue.id : "", // formData me sirf id save hogi
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Division"
                      variant="outlined"
                      error={!!formErrors.division}
                      helperText={formErrors.division}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  fullWidth
                  options={projects}
                  getOptionLabel={(option) => option.project_name || ""} // dropdown me kya show hoga
                  value={
                    projects.find((p) => p.id === formData.project) || null
                  } // selected value set karna
                  onChange={(event, newValue) => {
                    setFormData({
                      ...formData,
                      project: newValue ? newValue.id : "", // agar user select kare to id store ho
                    });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Project" variant="outlined"
                      error={!!formErrors.project}
                      helperText={formErrors.project} />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  fullWidth
                  options={purchases}
                  getOptionLabel={(option) => option.po_number || ""}
                  value={
                    purchases.find((p) => p.id === formData.purchase) || null
                  }
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setFormData((prev) => ({
                        ...prev,
                        purchase: newValue.id,
                        items: newValue.items.map((item) => ({
                          ...item,
                          category: item.category?.id || item.category,
                          category_name:
                            item.category?.name || item.category_name || "",
                          sub_category: item.sub_category?.subcat_id || item.sub_category,
                          item: item.item,
                          description: item.description,
                          unit: item.unit_name,
                          quantity: item.quantity || "",
                          rate: item.rate || "",
                          amount: item.amount || "",
                        })),
                      }));
                    }
                  }}
                  // 👈 updated handler
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Purchase Order"
                      variant="outlined"
                      error={!!formErrors.purchase}
                      helperText={formErrors.purchase}
                    />
                  )}
                />
              </Grid>

              {/* <TableContainer> */}
              <TableContainer sx={{ mt: 2 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow
                      sx={{
                        backgroundColor: "#f5f5f5",
                        "& th": {
                          fontWeight: "bold",
                          color: "#333",
                          borderBottom: "1px solid #999",
                          whiteSpace: "nowrap",
                        },
                      }}
                    >
                      <TableCell>Sl. No.</TableCell>
                      <TableCell>Category</TableCell>
                      <TableCell>Sub Category</TableCell>
                      <TableCell>Item</TableCell>
                      <TableCell>UOM</TableCell>
                      <TableCell>PO Qty.</TableCell>
                      <TableCell>Received Qty.</TableCell>
                      <TableCell>Rate</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Delete</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {/* {rows.map((row, index) => ( */}
                    {formData.items.map((row, index) => (
                      <TableRow key={index}>
                        {/* Sl. No. */}
                        <TableCell>{index + 1}</TableCell>

                        {/* Category */}
                        <TableCell>
                          <TextField
                            value={row.category_name}
                            size="small"
                            sx={{
                              minWidth: 180,
                              "& .MuiInputBase-root": { height: 40 },
                            }}
                            disabled
                          />
                        </TableCell>

                        {/* Subcategory */}
                        <TableCell>
                          <TextField
                            value={row.sub_category_name}
                            size="small"
                            sx={{
                              minWidth: 180,
                              "& .MuiInputBase-root": { height: 40 },
                            }}
                            disabled
                          />
                        </TableCell>

                        {/* Item */}
                        <TableCell>
                          <TextField
                            value={row.item_name}
                            size="small"
                            sx={{
                              minWidth: 180,
                              "& .MuiInputBase-root": { height: 40 },
                            }}
                            disabled
                          />
                        </TableCell>

                        {/* UOM */}
                        <TableCell>
                          <TextField
                            value={row.unit_name}
                            sx={{
                              minWidth: 180,
                              "& .MuiInputBase-root": { height: 40 },
                            }}
                            disabled
                          />
                        </TableCell>

                        {/* Required Qty */}
                        <TableCell>
                          <TextField
                            type="number"
                            size="small"

                            value={row.quantity || ""}
                            onChange={(e) => handleInputChange(index, "quantity", e.target.value)}
                            sx={{
                              minWidth: 180,
                              "& .MuiInputBase-root": { height: 40 },
                            }}
                            disabled
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            size="small"
                            value={row.received_qty || ""}
                            onChange={(e) => handleInputChange(index, "received_qty", e.target.value)}
                            sx={{
                              minWidth: 180,
                              "& .MuiInputBase-root": { height: 40 },
                            }}
                            error={!!formErrors.received_qty}
                          />
                        </TableCell>
                        {/* Rate */}
                        <TableCell>
                          <TextField
                            type="number"
                            size="small"
                            value={row.rate || ""}
                            onChange={(e) => handleInputChange(index, "rate", e.target.value)}
                            sx={{
                              minWidth: 180,
                              "& .MuiInputBase-root": { height: 40 },
                            }}
                            error={!!formErrors.rate}
                          />
                        </TableCell>

                        {/* Amount */}
                        <TableCell>
                          <TextField
                            size="small"
                            value={row.amount || ""}
                            onChange={(e) => handleInputChange(index, "amount", e.target.value)}
                            // InputProps={{ readOnly: true }}
                            sx={{
                              minWidth: 180,
                              "& .MuiInputBase-root": { height: 40 },
                              backgroundColor: "#f5f5f5",
                            }}
                            error={!!formErrors.amount}
                          />
                        </TableCell>

                        {/* Delete button */}
                        <TableCell>
                          <IconButton
                            color="error"
                            onClick={() => removeItem(index)}
                          >
                            <DeleteOutlineIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

             
            </Grid>
          </form>
        </Container>
        
      </Box>
    </Box>
  );
};

export default GoodReceivedForm;
